import React from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';

const GrammarBlockEditor = ({ block, onUpdate }) => {
    const exercises = block.exercises || [];

    const addExercise = () => {
        onUpdate({
            exercises: [...exercises, {
                title: '',
                type: 'multiple_choice',
                instructions: '',
                questions: []
            }]
        });
    };

    const removeExercise = (index) => {
        onUpdate({
            exercises: exercises.filter((_, i) => i !== index)
        });
    };

    const updateExercise = (index, field, value) => {
        onUpdate({
            exercises: exercises.map((ex, i) => 
                i === index ? { ...ex, [field]: value } : ex
            )
        });
    };

    const addQuestion = (exerciseIndex) => {
        const exercise = exercises[exerciseIndex];
        const newQuestion = {
            questionText: '',
            questionData: {},
            correctAnswer: '',
            explanation: '',
            points: 1
        };

        switch (exercise.type) {
            case 'multiple_choice':
                newQuestion.questionData = { options: ['', '', '', ''] };
                newQuestion.correctAnswer = 0;
                break;
            case 'true_false':
                newQuestion.questionData = {};
                newQuestion.correctAnswer = true;
                break;
            case 'fill_gaps':
                newQuestion.questionData = { sentence: '', gaps: [] };
                newQuestion.correctAnswer = [];
                break;
            case 'match':
                newQuestion.questionData = { pairs: [{ left: '', right: '' }] };
                newQuestion.correctAnswer = {};
                break;
            case 'arrange':
                newQuestion.questionData = { words: [] };
                newQuestion.correctAnswer = [];
                break;
            case 'text_answer':
                newQuestion.questionData = {};
                newQuestion.correctAnswer = '';
                break;
            default:
                break;
        }

        updateExercise(exerciseIndex, 'questions', [...exercise.questions, newQuestion]);
    };

    const removeQuestion = (exerciseIndex, questionIndex) => {
        const exercise = exercises[exerciseIndex];
        updateExercise(
            exerciseIndex,
            'questions',
            exercise.questions.filter((_, i) => i !== questionIndex)
        );
    };

    const updateQuestion = (exerciseIndex, questionIndex, field, value) => {
        const exercise = exercises[exerciseIndex];
        const updatedQuestions = exercise.questions.map((q, i) =>
            i === questionIndex ? { ...q, [field]: value } : q
        );
        updateExercise(exerciseIndex, 'questions', updatedQuestions);
    };

    const renderQuestionEditor = (exercise, exerciseIndex, question, questionIndex) => {
        switch (exercise.type) {
            case 'multiple_choice':
                return (
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>Текст вопроса</label>
                        <input
                            type="text"
                            value={question.questionText}
                            onChange={(e) => updateQuestion(exerciseIndex, questionIndex, 'questionText', e.target.value)}
                            placeholder="Например: What is the capital of France?"
                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', marginBottom: '10px' }}
                        />

                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>
                            Варианты ответов (можно отметить несколько правильных)
                        </label>
                        {(question.questionData?.options || []).map((option, optIndex) => {
                            const selectedCorrect = Array.isArray(question.correctAnswer)
                                ? question.correctAnswer
                                : (question.correctAnswer === '' || question.correctAnswer == null ? [] : [question.correctAnswer]);
                            const isChecked = selectedCorrect.includes(optIndex);
                            return (
                            <div key={optIndex} style={{ display: 'flex', gap: '8px', marginBottom: '6px', alignItems: 'center' }}>
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={() => {
                                        let next = Array.isArray(question.correctAnswer)
                                            ? [...question.correctAnswer]
                                            : (question.correctAnswer === '' || question.correctAnswer == null ? [] : [question.correctAnswer]);
                                        if (isChecked) {
                                            next = next.filter((i) => i !== optIndex);
                                        } else {
                                            next.push(optIndex);
                                        }
                                        next.sort((a, b) => a - b);
                                        const value = next.length <= 1 ? (next[0] ?? '') : next;
                                        updateQuestion(exerciseIndex, questionIndex, 'correctAnswer', value);
                                    }}
                                />
                                <input
                                    type="text"
                                    style={{ flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                                    value={option}
                                    onChange={(e) => {
                                        const newOptions = [...question.questionData.options];
                                        newOptions[optIndex] = e.target.value;
                                        updateQuestion(exerciseIndex, questionIndex, 'questionData', {
                                            ...question.questionData,
                                            options: newOptions
                                        });
                                    }}
                                    placeholder={`Вариант ${optIndex + 1}`}
                                />
                            </div>
                            );
                        })}
                    </div>
                );

            case 'true_false':
                return (
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>Утверждение</label>
                        <textarea
                            value={question.questionText}
                            onChange={(e) => updateQuestion(exerciseIndex, questionIndex, 'questionText', e.target.value)}
                            rows={2}
                            placeholder="Например: The Earth is flat."
                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', marginBottom: '10px' }}
                        />

                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>Правильный ответ</label>
                        <div style={{ display: 'flex', gap: '15px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                <input
                                    type="radio"
                                    name={`true-false-${exerciseIndex}-${questionIndex}`}
                                    checked={question.correctAnswer === true}
                                    onChange={() => updateQuestion(exerciseIndex, questionIndex, 'correctAnswer', true)}
                                />
                                <span>Правда (True)</span>
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                <input
                                    type="radio"
                                    name={`true-false-${exerciseIndex}-${questionIndex}`}
                                    checked={question.correctAnswer === false}
                                    onChange={() => updateQuestion(exerciseIndex, questionIndex, 'correctAnswer', false)}
                                />
                                <span>Ложь (False)</span>
                            </label>
                        </div>
                    </div>
                );

            case 'fill_gaps': {
                const gapsData = question.questionData || { sentence: '', gaps: [] };
                const correctAnswers = Array.isArray(question.correctAnswer) ? question.correctAnswer : [];

                const formatGapForInput = (answer) => {
                    if (Array.isArray(answer)) return answer.join(', ');
                    return answer || '';
                };

                const parseGapInput = (value) => {
                    const parts = value.split(',').map((s) => s.trim()).filter(Boolean);
                    if (parts.length <= 1) return parts[0] || '';
                    return parts;
                };
                
                return (
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>
                            Предложение с пропусками
                        </label>
                        <p style={{ fontSize: '11px', color: '#999', marginBottom: '6px' }}>
                            Используйте ___ для обозначения пропуска
                        </p>
                        <textarea
                            value={gapsData.sentence || ''}
                            onChange={(e) => {
                                const sentence = e.target.value;
                                const gaps = (sentence.match(/___/g) || []).length;
                                
                                const exercise = exercises[exerciseIndex];
                                const updatedQuestions = exercise.questions.map((q, i) =>
                                    i === questionIndex ? {
                                        ...q,
                                        questionData: { sentence, gaps: Array(gaps).fill('') },
                                        correctAnswer: Array(gaps).fill('')
                                    } : q
                                );
                                updateExercise(exerciseIndex, 'questions', updatedQuestions);
                            }}
                            rows={2}
                            placeholder="I ___ to school every day."
                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', marginBottom: '10px' }}
                        />

                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>
                            Правильные ответы для пропусков
                        </label>
                        <p style={{ fontSize: '11px', color: '#999', margin: '0 0 8px 0' }}>
                            Несколько допустимых вариантов для одного пропуска — через запятую (например: go, goes, went)
                        </p>
                        {correctAnswers.length > 0 ? (
                            correctAnswers.map((answer, gapIndex) => (
                                <input
                                    key={gapIndex}
                                    type="text"
                                    style={{ width: '100%', marginBottom: '6px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                                    value={formatGapForInput(answer)}
                                    onChange={(e) => {
                                        const newAnswers = [...correctAnswers];
                                        newAnswers[gapIndex] = parseGapInput(e.target.value);
                                        updateQuestion(exerciseIndex, questionIndex, 'correctAnswer', newAnswers);
                                    }}
                                    placeholder={`Пропуск ${gapIndex + 1}: слово или вариант1, вариант2`}
                                />
                            ))
                        ) : (
                            <p style={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
                                Сначала добавьте предложение с пропусками (___)
                            </p>
                        )}
                    </div>
                );
            }

            case 'match':
                return (
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>Инструкция</label>
                        <input
                            type="text"
                            value={question.questionText}
                            onChange={(e) => updateQuestion(exerciseIndex, questionIndex, 'questionText', e.target.value)}
                            placeholder="Соедините слова с их переводом"
                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', marginBottom: '10px' }}
                        />

                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>Пары для сопоставления</label>
                        {(question.questionData?.pairs || []).map((pair, pairIndex) => (
                            <div key={pairIndex} style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                                <input
                                    type="text"
                                    style={{ flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                                    value={pair.left}
                                    onChange={(e) => {
                                        const newPairs = [...question.questionData.pairs];
                                        newPairs[pairIndex].left = e.target.value;
                                        updateQuestion(exerciseIndex, questionIndex, 'questionData', {
                                            ...question.questionData,
                                            pairs: newPairs
                                        });
                                    }}
                                    placeholder="Слева"
                                />
                                <span style={{ lineHeight: '40px' }}>↔</span>
                                <input
                                    type="text"
                                    style={{ flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                                    value={pair.right}
                                    onChange={(e) => {
                                        const newPairs = [...question.questionData.pairs];
                                        newPairs[pairIndex].right = e.target.value;
                                        updateQuestion(exerciseIndex, questionIndex, 'questionData', {
                                            ...question.questionData,
                                            pairs: newPairs
                                        });
                                    }}
                                    placeholder="Справа"
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        const newPairs = question.questionData.pairs.filter((_, i) => i !== pairIndex);
                                        updateQuestion(exerciseIndex, questionIndex, 'questionData', {
                                            ...question.questionData,
                                            pairs: newPairs
                                        });
                                    }}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        color: '#ff4d4f',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <FiTrash2 />
                                </button>
                            </div>
                        ))}
                        <button
                            type="button"
                            onClick={() => {
                                const newPairs = [...(question.questionData?.pairs || []), { left: '', right: '' }];
                                updateQuestion(exerciseIndex, questionIndex, 'questionData', {
                                    ...question.questionData,
                                    pairs: newPairs
                                });
                            }}
                            style={{
                                padding: '6px 12px',
                                background: '#52c41a',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '12px'
                            }}
                        >
                            + Добавить пару
                        </button>
                    </div>
                );

            case 'arrange':
                const arrangeSentence = question.questionData?.sentence || question.correctAnswer?.join(' ') || '';
                
                return (
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>Инструкция</label>
                        <input
                            type="text"
                            value={question.questionText || ''}
                            onChange={(e) => updateQuestion(exerciseIndex, questionIndex, 'questionText', e.target.value)}
                            placeholder="Расставьте слова в правильном порядке"
                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', marginBottom: '10px' }}
                        />

                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>
                            Правильное предложение
                        </label>
                        <p style={{ fontSize: '11px', color: '#999', marginBottom: '6px' }}>
                            Введите предложение. Оно будет разбито на слова и перемешано
                        </p>
                        <input
                            type="text"
                            value={arrangeSentence}
                            onChange={(e) => {
                                const text = e.target.value;
                                const words = text.trim() ? text.trim().split(/\s+/) : [];
                                
                                const exercise = exercises[exerciseIndex];
                                const updatedQuestions = exercise.questions.map((q, i) =>
                                    i === questionIndex ? {
                                        ...q,
                                        correctAnswer: words,
                                        questionData: { sentence: text, words }
                                    } : q
                                );
                                updateExercise(exerciseIndex, 'questions', updatedQuestions);
                            }}
                            placeholder="I go to school every day"
                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                        />
                    </div>
                );

            case 'text_answer':
                return (
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>Задание</label>
                        <textarea
                            value={question.questionText || ''}
                            onChange={(e) => updateQuestion(exerciseIndex, questionIndex, 'questionText', e.target.value)}
                            placeholder="Вопрос или инструкция для письменного ответа"
                            rows={3}
                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', marginBottom: '10px' }}
                        />
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>
                            Образец ответа (для проверки; в тесте ученику не показывается)
                        </label>
                        <textarea
                            value={typeof question.correctAnswer === 'string' ? question.correctAnswer : ''}
                            onChange={(e) => updateQuestion(exerciseIndex, questionIndex, 'correctAnswer', e.target.value)}
                            rows={2}
                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                        />
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div style={{ display: 'grid', gap: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ margin: 0 }}>Упражнения ({exercises.length})</h3>
                <button
                    type="button"
                    onClick={addExercise}
                    style={{
                        padding: '10px 16px',
                        background: '#52c41a',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        fontWeight: '500'
                    }}
                >
                    <FiPlus /> Добавить упражнение
                </button>
            </div>

            {exercises.length === 0 && (
                <div style={{
                    padding: '40px',
                    textAlign: 'center',
                    background: '#f9f9f9',
                    borderRadius: '8px',
                    color: '#999'
                }}>
                    Нет упражнений. Нажмите "Добавить упражнение"
                </div>
            )}

            {exercises.map((exercise, exIndex) => (
                <div
                    key={exIndex}
                    style={{
                        padding: '20px',
                        background: '#f5f5f5',
                        borderRadius: '8px',
                        border: '2px solid #e0e0e0'
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                        <h4 style={{ margin: 0 }}>Упражнение {exIndex + 1}</h4>
                        <button
                            type="button"
                            onClick={() => removeExercise(exIndex)}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#ff4d4f',
                                cursor: 'pointer',
                                fontSize: '18px'
                            }}
                        >
                            <FiTrash2 />
                        </button>
                    </div>

                    <div style={{ display: 'grid', gap: '15px' }}>
                        <div>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Название упражнения</label>
                            <input
                                type="text"
                                value={exercise.title}
                                onChange={(e) => updateExercise(exIndex, 'title', e.target.value)}
                                placeholder="Например: Выберите правильный ответ"
                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                            />
                        </div>

                        <div>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Тип упражнения</label>
                            <select
                                value={exercise.type}
                                onChange={(e) => {
                                    const newType = e.target.value;
                                    const updatedExercises = [...exercises];
                                    updatedExercises[exIndex] = {
                                        ...updatedExercises[exIndex],
                                        type: newType,
                                        questions: []
                                    };
                                    onUpdate({ exercises: updatedExercises });
                                }}
                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                            >
                                <option value="multiple_choice">Выбор ответа</option>
                                <option value="true_false">Правда/Ложь</option>
                                <option value="fill_gaps">Заполнить пропуски</option>
                                <option value="match">Сопоставление</option>
                                <option value="arrange">Расставить слова</option>
                                <option value="text_answer">Текстовый ответ</option>
                            </select>
                        </div>

                        <div>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Инструкции</label>
                            <textarea
                                value={exercise.instructions}
                                onChange={(e) => updateExercise(exIndex, 'instructions', e.target.value)}
                                rows={2}
                                placeholder="Краткое описание задания"
                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                            />
                        </div>

                        {/* Вопросы */}
                        <div style={{ borderTop: '1px solid #ddd', paddingTop: '15px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                <span style={{ fontWeight: '600' }}>Вопросы ({exercise.questions.length})</span>
                                <button
                                    type="button"
                                    onClick={() => addQuestion(exIndex)}
                                    style={{
                                        padding: '6px 12px',
                                        background: '#4a90e2',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '12px'
                                    }}
                                >
                                    + Добавить вопрос
                                </button>
                            </div>

                            {exercise.questions.length === 0 && (
                                <div style={{
                                    padding: '20px',
                                    textAlign: 'center',
                                    background: 'white',
                                    borderRadius: '6px',
                                    color: '#999',
                                    fontSize: '13px'
                                }}>
                                    Нет вопросов
                                </div>
                            )}

                            {exercise.questions.map((question, qIndex) => (
                                <div
                                    key={qIndex}
                                    style={{
                                        padding: '15px',
                                        background: 'white',
                                        borderRadius: '6px',
                                        marginBottom: '10px',
                                        border: '1px solid #e0e0e0'
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                                        <span style={{ fontSize: '13px', fontWeight: '600' }}>
                                            Вопрос {qIndex + 1}
                                        </span>
                                        <button
                                            type="button"
                                            onClick={() => removeQuestion(exIndex, qIndex)}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                color: '#ff4d4f',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <FiTrash2 size={16} />
                                        </button>
                                    </div>

                                    {renderQuestionEditor(exercise, exIndex, question, qIndex)}

                                    <div style={{ marginTop: '12px' }}>
                                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>
                                            Объяснение (необязательно)
                                        </label>
                                        <textarea
                                            value={question.explanation}
                                            onChange={(e) => updateQuestion(exIndex, qIndex, 'explanation', e.target.value)}
                                            rows={2}
                                            placeholder="Объяснение правильного ответа"
                                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                                        />
                                    </div>

                                    <div style={{ marginTop: '12px' }}>
                                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>
                                            Баллы за вопрос
                                        </label>
                                        <input
                                            type="number"
                                            value={question.points || 1}
                                            onChange={(e) => updateQuestion(exIndex, qIndex, 'points', parseInt(e.target.value) || 1)}
                                            min="1"
                                            style={{ width: '100px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default GrammarBlockEditor;
